import React, { memo } from "react";
import Skeleton from "@mui/material/Skeleton";

const CardSkeleton = ({ className, height = 280 }) => (
  <div
    className={`overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm ${className}`}
  >
    <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
      <div className="flex items-center gap-3">
        <Skeleton variant="rounded" width={40} height={40} />
        <div className="flex flex-col">
          <Skeleton variant="text" width={120} height={16} />
          <Skeleton variant="text" width={70} height={36} />
        </div>
      </div>
      <Skeleton variant="text" width={80} height={20} />
    </div>
    <div className="p-4">
      <Skeleton variant="rounded" width="100%" height={height} />
    </div>
  </div>
);

const DashboardSkeleton = memo(() => {
  return (
    <div className="Dashbord-page">
      <div className="flex flex-col gap-[24px]">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <Skeleton variant="rounded" width={40} height={40} />
            <Skeleton variant="text" width={140} height={24} />
          </div>
          <Skeleton
            variant="rounded"
            width={260}
            height={44}
            sx={{ borderRadius: "12px" }}
          />
        </div>

        <div className="grid grid-cols-12 gap-4">
          <CardSkeleton className="col-span-12 lg:col-span-8" />
          <CardSkeleton className="col-span-12 lg:col-span-4" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          <CardSkeleton className="col-span-12 lg:col-span-4" height={250} />
          <CardSkeleton className="col-span-12 lg:col-span-8" height={250} />
        </div>
      </div>
    </div>
  );
});

DashboardSkeleton.displayName = "DashboardSkeleton";

export default DashboardSkeleton;
